import { useDispatch, useSelector } from "react-redux";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import {
  initialFilterStateParameterCreation,
  tableHeaderParameterCreation,
} from "./helper";
import { useEffect } from "react";
import { getParameterCreationAction } from "../../../../redux/actions/TestPackageCreationAction";
import { useState } from "react";
import Modal from "react-modal";
import { AddParameterCreationPopup } from "./AddParameterCreationPopup";
import CustomPagination from "../../../../common/CustomPagination";
import { getNetworkMenuId, getToken } from "../../../../Utils/types";
import { API_URL_WITHOUT_USER } from "../../../../Utils/API";
import { TableHeaderAdmin } from "../../HelloAdmin/helper";

const ParameterCreationPage = ({ setIsRowDataTest, isRowDataTest }) => {
  const [searchFilterParameter, setSearchFilterParameter] = useState(
    initialFilterStateParameterCreation
  );
  const [multiSelect, setMultiSelect] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const dispatch = useDispatch();
  const [isAddParameter, setIsAddParamter] = useState({
    isOpen: false,
    rowData: null,
  });
  const globalReducer = useSelector((state) => state?.globalReducer);
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer
  );

  useEffect(() => {
    if (isRowDataTest !== null) {
      setSearchFilterParameter({
        ...searchFilterParameter,
        testId: isRowDataTest?.productFacilityId,
      });
      dispatch(
        getParameterCreationAction({
          ...searchFilterParameter,
          testId: isRowDataTest?.productFacilityId,
        })
      );
    }
  }, [isRowDataTest]);

  const changeHandler = (name, value) => {
    setSearchFilterParameter({ ...searchFilterParameter, [name]: value });
  };

  const handleSearch = () => {
    setSearchFilterParameter({ ...searchFilterParameter, page: 1 });
    dispatch(getParameterCreationAction({ ...searchFilterParameter, page: 1 }));
  };

  const handleClearFilter = () => {
    setSearchFilterParameter({
      ...initialFilterStateParameterCreation,
      testId: isRowDataTest?.productFacilityId,
    });
    dispatch(
      getParameterCreationAction({
        ...initialFilterStateParameterCreation,
        testId: isRowDataTest?.productFacilityId,
      })
    );
    setMultiSelect([]);
    setSelectAll(false);
  };

  const SortHandler = (sortColumnName, sortDirection) => {
    setSearchFilterParameter({
      ...searchFilterParameter,
      page: 1,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
    });
    dispatch(
      getParameterCreationAction({
        ...searchFilterParameter,
        page: 1,
        SortColumn: sortColumnName,
        sortDirection: sortDirection,
      })
    );
  };

  const downloadFile = () => {
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/Test/ExportToExcelTestParameters`;
    const data = {
      ...searchFilterParameter,
      testParameterIds: selectAll ? "" : multiSelect?.toString(),
      page: undefined,
      rows: undefined,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const filename = "parametercreation.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };

  const testParameterIds =
    TestPackageCreationReducer?.getParameterCreation?.map((ele) => {
      return ele?.testParameterId;
    });

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <div
            className="back-buttondiv"
            onClick={() => {
              setIsRowDataTest(null);
            }}
          >
            <i className="fa-solid fa-circle-arrow-left"></i>
            <h6 style={{ cursor: "pointer" }}>Back</h6>
          </div>
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            Parameter Creation ({isRowDataTest?.testName})
          </h4>
          <div className="row-filter">
            <input
              type="text"
              placeholder="Parameter Name"
              className="white-form-select"
              value={searchFilterParameter?.TestParameterName}
              onChange={(e) =>
                changeHandler("TestParameterName", e.target.value)
              }
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleSearch(event);
                }
              }}
            />
            <select
              className="white-form-select"
              value={
                searchFilterParameter?.isActive === null
                  ? ""
                  : searchFilterParameter?.isActive
              }
              onChange={(e) =>
                changeHandler(
                  "isActive",
                  e.target.value === "true"
                    ? true
                    : e.target.value === "false"
                      ? false
                      : e.target.value === "" && null
                )
              }
            >
              <option value="">Select Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>
            <div className="search" type="button" onClick={handleSearch}>
              <a className="sidebar-links">
                <SearchIcon />
                <span className="sidebar-link-text">Search</span>
              </a>
            </div>
            <div className="search" type="button" onClick={handleClearFilter}>
              <a className="sidebar-links">
                <span className="sidebar-link-text">Clear All</span>
              </a>
            </div>
          </div>
          <div className="row-results">
            <div className="d-flex gap-10">
              <select
                className="row-selectdropdown"
                value={searchFilterParameter?.rows}
                onChange={(e) => {
                  setSearchFilterParameter({
                    ...searchFilterParameter,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    getParameterCreationAction({
                      ...searchFilterParameter,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
              <div className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </div>
            </div>
            <div>
              {multiSelect?.length ? (
                <div className="select_all_div">
                  {!selectAll && (
                    <>
                      <p>{multiSelect?.length} parameter are selected</p>
                      <span
                        className="select_all_primary_cases"
                        onClick={() => setSelectAll(true)}
                      >
                        Select all {globalReducer?.getTotalCount} parameter
                      </span>
                    </>
                  )}
                  {selectAll && (
                    <p>{globalReducer?.getTotalCount} parameter are selected</p>
                  )}
                </div>
              ) : null}
            </div>
            <div className="d-flex gap-10">
              {getNetworkMenuId()?.canEdit &&
                <button
                  className={`btn search__btn`}
                  type="button"
                  onClick={() =>
                    setIsAddParamter({ isOpen: true, rowData: null })
                  }
                >
                  <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp; Create
                  Parameter
                </button>}
              <button
                className={`btn ${!isLoadingExcel ? "search__btn" : "disabled_btn"
                  }`}
                type="button"
                onClick={() => !isLoadingExcel && downloadFile()}
                disabled={!multiSelect?.length}
              >
                <i className="fa-solid fa-arrow-down"></i>&nbsp;
                {isLoadingExcel ? "Exporting..." : "Export To Excel"}
              </button>
            </div>
          </div>
          <div className="table-responsive __custom__properties">
            <table className="table">
              <thead>
                <tr className="avanishtbl">
                  <th>
                    <input
                      type="checkbox"
                      onClick={(e) =>
                        e?.target?.checked
                          ? (setSelectAll(false),
                            setMultiSelect([
                              ...new Set(
                                [
                                  ...multiSelect,
                                  ...TestPackageCreationReducer?.getParameterCreation?.map(
                                    (ele) => {
                                      return ele?.testParameterId;
                                    }
                                  ),
                                ].map((item) => item)
                              ),
                            ]))
                          : (setSelectAll(false),
                            setMultiSelect(
                              multiSelect?.length === 10
                                ? []
                                : multiSelect?.filter(
                                  (item) => !testParameterIds.includes(item)
                                )
                            ))
                      }
                      checked={testParameterIds?.every((r) =>
                        multiSelect?.includes(r)
                      )}
                      className="form-check-input"
                      readOnly
                    />
                  </th>
                  {tableHeaderParameterCreation?.map((ele, index) => {
                    return (
                      <TableHeaderAdmin
                        key={index}
                        header={ele?.name}
                        searchFilter={searchFilterParameter}
                        SortHandler={SortHandler}
                      />
                    );
                  })}
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {TestPackageCreationReducer?.getParameterCreation?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td className="pl-18">
                          <input
                            type="checkbox"
                            onClick={(e) =>
                              e?.target?.checked
                                ? (setSelectAll(false),
                                  setMultiSelect([
                                    ...multiSelect,
                                    ele?.testParameterId,
                                  ]))
                                : (setSelectAll(false),
                                  setMultiSelect(
                                    multiSelect.filter(
                                      (value) => value !== ele?.testParameterId
                                    )
                                  ))
                            }
                            checked={multiSelect?.some(
                              (element) => element === ele?.testParameterId
                            )}
                            className="form-check-input"
                            readOnly
                          />
                        </td>
                        <td
                          className={`${ele?.isActive ? "tbl-textgreen" : "tbl-textred"
                            }`}
                        >
                          {ele?.testParameterName}
                        </td>
                        <td>
                          {ele?.hvChargesFor === "" ? "-" : ele?.hvChargesFor}
                        </td>
                        <td>{ele?.isFasting ? "Yes" : "No"}</td>
                        <td>{ele?.isHomeVisit ? "Yes" : "No"}</td>
                        <td>{ele?.isActive ? "Yes" : "No"}</td>
                        <td
                          className="tbl-actionimg"
                          style={{
                            cursor: !getNetworkMenuId()?.canEdit
                              ? "default"
                              : "pointer",
                          }}
                          onClick={() => {
                            if (getNetworkMenuId()?.canEdit) {
                              setIsAddParamter({
                                isOpen: true,
                                rowData: ele,
                              })
                            }
                          }}
                        >
                          <img
                            src=".././images/edit-icon.png"
                            alt="exportsquare"
                          />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-row">
            {globalReducer?.getTotalCount !== 0 && (
              <CustomPagination
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilterParameter?.rows}
                searchFilter={searchFilterParameter}
                setSearchFilter={setSearchFilterParameter}
                apiCall={getParameterCreationAction}
              />
            )}
          </div>
          <Modal
            isOpen={isAddParameter?.isOpen}
            className="modal-add-user-popup modal-role-user-popup modal-add-diagnostic"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AddParameterCreationPopup
              isAddParameter={isAddParameter}
              setIsAddParamter={setIsAddParamter}
              isRowDataTest={isRowDataTest}
              searchFilterParameter={searchFilterParameter}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ParameterCreationPage;
